export default function Packages({ packages, onEnquire }) {
  return (
    <section id="packages" className="section packages">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow" style={{ color: "var(--gold-soft)" }}>
            Bundled care
          </span>
          <h2>Care packages</h2>
          <p>Curated bundles built around a health goal — designed to work together for the best results.</p>
        </div>
        <div className="pkg-grid">
          {packages.map((p) => (
            <div className="pkg-card" key={p.id}>
              <div className="ic">
                <i className={`fa-solid ${p.icon}`} />
              </div>
              <h3>{p.name}</h3>
              <p>{p.description}</p>
              <button onClick={() => onEnquire(p.name)}>
                <i className="fa-brands fa-whatsapp" /> Enquire
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
